import request, { METHODS } from '@/api'
import UrlConfig, { getEnumURL } from '@/api/UrlConfigs'
import { get } from 'lodash-es'
interface ApiResponse {
  list?: any[]
  count?: number
}
//财务-收款服务
/**
 *  获取枚举值
 */
export const getEnum = (path: string) => {
  return request(`${UrlConfig.PlusFmsWeb.GetPlusEnums}${path}`, {
    method: METHODS.GET,
  })
    .then(res => {
      return res || []
    })
    .catch(() => [])
}
/*
 *    枚举  -- Esign
 * */
export const getEnumEsign = path => {
  return request(getEnumURL('esign', path), {
    method: METHODS.GET,
  })
}
/**
 * 获取数据字典 - 租户
 * @param params 参数  { key: 'productionType', enable: '1' }
 * @returns
 */
export const httpDictServTenant = (
  data: { parentKey: string; enable: string | number } | { [key: string]: any }
) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.PlusProductWeb.GetDataDictionaryList, {
      method: METHODS.POST,
      data,
    })
    resolve(resData || [])
  })
}
/**
 * 获取数据字典-平台
 * @param params 参数  { key: 'productionType', enable: '1' }
 * @returns
 */
export const httpDictServ = (
  data: { parentKey: string; enable: string | number } | { [key: string]: any }
) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Platform.DataDictionary, {
      method: METHODS.POST,
      data,
    })
    resolve(resData.list || [])
  })
}
/**
 * 获取财务主体列表  后续可能需要改
 * @param {string} data.companyType - 类型  group:集团  company:门店
 */
export const httpCompanyList = (data?: {}) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Caas.GetCompanySearchList, {
      method: METHODS.POST,
      data: {
        enabled: true,
        companyType: 'company',
        ...data,
      },
    })
    resolve(resData)
  })
}

export const findResponseListByPage = async (
  current: number,
  pageSize: number,
  params: Record<string, unknown>
): Promise<{ records: any[]; total: number }> => {
  const url = `${UrlConfig.PlusFmsWeb.FindResponseListByPage}?current=${current}&pageSize=${pageSize}`

  try {
    const resp = (await request(url, {
      method: METHODS.POST,
      data: params,
    })) as ApiResponse
    return {
      records: resp.list || [],
      total: resp.count || 0,
    }
  } catch (error) {
    console.error('获取列表失败:', error)
    return { records: [], total: 0 }
  }
}
//收款计划异常
export const findRulesPlanErrCountResponse = data => {
  return request(`${UrlConfig.PlusFmsWeb.FindRulesPlanErrCountResponse}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const custAccountPrint = data => {
  return request(`${UrlConfig.PlusFmsWeb.CustAccountPrint}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const custAccountPrePrint = data => {
  return request(`${UrlConfig.PlusFmsWeb.CustAccountPrePrint}`, {
    method: METHODS.GET,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}

export const getRulesPlanMainPage = options => {
  return request(`${UrlConfig.PlusFmsWeb.GetRulesPlanMainPage}`, {
    method: METHODS.POST,
    ...options,
  }).then((resp: any) => {
    return resp
  })
}
//收款明细
export const transactionJournalFindListByPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.TransactionJournalFindListByPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const transactionJournalSaveOrUpdate = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransactionJournalSaveOrUpdate}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const transactionJournalSaveAndReceiveToAccount = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransactionJournalSaveAndReceiveToAccount}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const transactionJournalReceiveToAccount = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransactionJournalReceiveToAccount}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const transactionJournalComfireToAccount = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransactionJournalComfireToAccount}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const comfireToAccountBatch = data => {
  return request(`${UrlConfig.PlusFmsWeb.ComfireToAccountBatch}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const transactionJournalDelete = id => {
  return request(`${UrlConfig.PlusFmsWeb.TransactionJournalDelete}?id=${id}`, {
    method: METHODS.DELETE,
  })
}
export const sendKdMsgAgain = data => {
  return request(`${UrlConfig.PlusFmsWeb.SendKdMsgAgain}`, {
    method: METHODS.POST,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
//核销明细查询
export const findVerifyApplyResponseList = data => {
  return request(`${UrlConfig.PlusFmsWeb.FindVerifyApplyResponseList}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    const records = resp
    const total = records.length || 0
    return { records, total }
  })
}
export const verifyApplyFindResponseListByPage = (current, pageSize, data) => {
  return request(
    `${UrlConfig.PlusFmsWeb.VerifyApplyFindResponseListByPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const cancelVerify = data => {
  return request(`${UrlConfig.PlusFmsWeb.CancelVerify}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const findCanVerifyApplyBillResponse = data => {
  return request(`${UrlConfig.PlusFmsWeb.FindCanVerifyApplyBillResponse}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
//异常列表
export const rulesPlanErrListByPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.RulesPlanErrListByPage}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const rulesPlanErrListByRetry = data => {
  return request(`${UrlConfig.PlusFmsWeb.RulesPlanErrListByRetry}`, {
    method: METHODS.GET,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
export const rulesPlanErrCloseOrderById = data => {
  return request(`${UrlConfig.PlusFmsWeb.RulesPlanErrCloseOrderById}`, {
    method: METHODS.GET,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
//
export const receiptApplyPageList = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.ReceiptApplyPageList}?pageId=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const addVerifyApplyForHandle = data => {
  return request(`${UrlConfig.PlusFmsWeb.AddVerifyApplyForHandle}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const findQuotationTypes = () => {
  return request(`${UrlConfig.PlusFmsWeb.FindQuotationTypes}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
export const receiptApply = (data, id) => {
  return request(`${UrlConfig.PlusFmsWeb.ReceiptApply}`, {
    method: METHODS.POST,
    params: {
      orderAccountId: id,
    },
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const receiptApplySubmit = (data, id) => {
  return request(`${UrlConfig.PlusFmsWeb.ReceiptApplySubmit}`, {
    method: METHODS.POST,
    params: {
      orderAccountId: id,
    },
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const sendTransactionElecListByTransactionId = id => {
  return request(`${UrlConfig.PlusFmsWeb.SendTransactionElecListByTransactionId}`, {
    method: METHODS.POST,
    params: {
      transactionId: id,
    },
  }).then((resp: any) => {
    return resp
  })
}
export const exportToExportTask = data => {
  return request(`${UrlConfig.PlusFmsWeb.DownloadTransactionElecList}`, {
    method: METHODS.POST,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
export const modifyTransactionAmount = data => {
  return request(`${UrlConfig.PlusFmsWeb.ModifyTransactionAmount}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 收款
export const findCanPaymentApplyResponseForHandle = data => {
  return request(`${UrlConfig.PlusFmsWeb.FindCanPaymentApplyResponseForHandle}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const paymentApplyForHandle = data => {
  return request(`${UrlConfig.PlusFmsWeb.PaymentApplyForHandle}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const transactionCalDtlFindCalListByRequest = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransactionCalDtlFindCalListByRequest}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const custServiceBillCalFindCalListByRequest = data => {
  return request(`${UrlConfig.PlusFmsWeb.CustServiceBillCalFindCalListByRequest}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const transactionCalDtlFindCalType = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransactionCalDtlFindCalType}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const custServiceBillCalFindCalType = data => {
  return request(`${UrlConfig.PlusFmsWeb.CustServiceBillCalFindCalType}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const paymentApplyAddAndVerfiyBatch = data => {
  return request(`${UrlConfig.PlusFmsWeb.PaymentApplyAddAndVerfiyBatch}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const findOrderAccountDtlResponseByRequest = data => {
  return request(`${UrlConfig.PlusFmsWeb.FindOrderAccountDtlResponseByRequest}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
//发票
export const orderInvoiceList = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.OrderInvoiceList}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const orderInvoiceSaveOrUpdate = data => {
  return request(`${UrlConfig.PlusFmsWeb.OrderInvoiceSaveOrUpdate}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const orderInvoiceDelete = data => {
  return request(`${UrlConfig.PlusFmsWeb.OrderInvoiceDelete}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 退款
export const refundApplyPageList = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.RefundApplyPageList}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const refundApplyLogList = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.RefundApplyLogList}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const refundApplyGet = id => {
  return request(`${UrlConfig.PlusFmsWeb.RefundApplyGet}?id=${id}`, {
    method: METHODS.GET,
  }).then((resp: any) => {
    return resp
  })
}
export const refundApplyUpdateRefundApplyInfo = data => {
  return request(`${UrlConfig.PlusFmsWeb.RefundApplyUpdateRefundApplyInfo}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const refundApplyUpdateRefundApplyPayState = data => {
  return request(`${UrlConfig.PlusFmsWeb.RefundApplyUpdateRefundApplyPayState}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const refundApplyConfirmToAccountForHandle = data => {
  return request(`${UrlConfig.PlusFmsWeb.RefundApplyConfirmToAccountForHandle}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const refundApplyReceiveToAccountForHandle = data => {
  return request(`${UrlConfig.PlusFmsWeb.RefundApplyReceiveToAccountForHandle}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const chooseChangePlanMain = data => {
  return request(`${UrlConfig.PlusFmsWeb.ChooseChangePlanMain}`, {
    method: METHODS.POST,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
export const selectUnionPlan = data => {
  return request(`${UrlConfig.PlusFmsWeb.SelectUnionPlan}`, {
    method: METHODS.POST,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
//转款
export const transferListByRequest = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransferListByRequest}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const addTransferApply = data => {
  return request(`${UrlConfig.PlusFmsWeb.AddTransferApply}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const transferFindResponseListByPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.TransferFindResponseListByPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
export const transferFindDetailResponseByRequest = data => {
  return request(`${UrlConfig.PlusFmsWeb.TransferFindDetailResponseByRequest}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
export const paymentApplySelectMainContractNo = data => {
  return request(`${UrlConfig.PlusFmsWeb.PaymentApplySelectMainContractNo}`, {
    method: METHODS.POST,
    params: data,
  }).then((resp: any) => {
    return resp
  })
}
// 分页查询京东款项列表
export const findJDResponseListByPage = async (current, pageSize, params) => {
  return request(
    UrlConfig.PlusFmsWeb.FindJDResponseListByPage + `?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  )
}
// 查询收款list
export const findReceiptApplyForJdPayResponseListByRequest = data => {
  return request(`${UrlConfig.PlusFmsWeb.FindReceiptApplyForJdPayResponseListByRequest}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 提交应收单查看收款类型
export const submitForPreViewList = data => {
  return request(`${UrlConfig.PlusFmsWeb.SubmitForPreViewList}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 新增京东收款
export const addOrUpdatePaymentApply = data => {
  return request(`${UrlConfig.PlusFmsWeb.AddOrUpdatePaymentApply}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 取消收款

export const cancelPaymentApply = data => {
  return request(`${UrlConfig.PlusFmsWeb.CancelPaymentApply}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 重新生成收款单
export const paymentPayedWithLog = data => {
  return request(`${UrlConfig.PlusFmsWeb.PaymentPayedWithLog}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 查询详情
export const findDetailResponseByRequest = data => {
  return request(`${UrlConfig.PlusFmsWeb.FindDetailResponseByRequest}`, {
    method: METHODS.POST,
    data,
  }).then((resp: any) => {
    return resp
  })
}
// 同步金蝶日志
export const searchResponsePageByParams = (current, pageSize, params) => {
    return request(
        `${UrlConfig.PlusFmsWeb.SearchResponsePageByParams}?current=${current}&pageSize=${pageSize}`,
        {
            method: METHODS.POST,
            data: params,
        }
    ).then((resp: any) => {
        const records = get(resp, 'list', [])
        const total = get(resp, 'count', 0)
        return { records, total }
    })
}
export const sendSyncKingdeeRecordMessageReqeust = data => {
    return request(`${UrlConfig.PlusFmsWeb.SendSyncKingdeeRecordMessageReqeust}`, {
        method: METHODS.POST,
        data
    }).then((resp: any) => {
        return resp
    })
}
export const receiptApplyDeleteApply = data => {
    return request(`${UrlConfig.PlusFmsWeb.receiptApplyDeleteApply}`, {
        method: METHODS.GET,
        params: data
    }).then((resp: any) => {
        return resp
    })
}
export const getSyncResultStatusList = data => {
    return request(`${UrlConfig.PlusFmsWeb.GetSyncResultStatusList}`, {
        method: METHODS.POST,
        data
    }).then((resp: any) => {
        return resp
    })
}
export const getOperateTypeList = data => {
    return request(`${UrlConfig.PlusFmsWeb.GetOperateTypeList}`, {
        method: METHODS.POST,
        data
    }).then((resp: any) => {
        return resp
    })
}
export const updateByIdCustomer = data => {
    return request(`${UrlConfig.PlusCrmWeb.UpdateByIdCustomer}`, {
        method: METHODS.POST,
        data
    }).then((resp: any) => {
        return resp
    })
}
// 应收明细-生效
export const handlerNoEffectiveData = params => {
    return request(`${UrlConfig.PlusFmsWeb.HandlerNoEffectiveData}`, {
        method: METHODS.GET,
        params,
    }).then((resp: any) => {
        return resp
    })
}
// 应收列表
export const receiptApplyFindResponseListByPageForMainPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.receiptApplyFindResponseListByPageForMainPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
// 收款列表
export const transactionJournalFindResponseListByPageForMainPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.transactionJournalFindResponseListByPageForMainPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
// 退款列表
export const refundApplyFindResponseListByPageForMainPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.PlusFmsWeb.refundApplyFindResponseListByPageForMainPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
/**
 *  获取枚举值
 */
export const getEnumGoodsFrontend = (path: string) => {
  return request(`${UrlConfig.GoodsFrontendTenantWeb.GetPlusEnums}${path}`, {
    method: METHODS.GET,
  })
    .then(res => {
      return res || []
    })
    .catch(() => [])
}
// 优惠券
export const findResponseForFmsListByPage = (current, pageSize, params) => {
  return request(
    `${UrlConfig.GoodsFrontendTenantWeb.FindResponseForFmsListByPage}?current=${current}&pageSize=${pageSize}`,
    {
      method: METHODS.POST,
      data: params,
    }
  ).then((resp: any) => {
    const records = get(resp, 'list', [])
    const total = get(resp, 'count', 0)
    return { records, total }
  })
}
// 根据订单号查询优惠券
export const findResponseForFmsListBySourceOrTargetOrderId = (data) => {
  return request(
    `${UrlConfig.GoodsFrontendTenantWeb.FindResponseForFmsListBySourceOrTargetOrderId}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    return resp
  })
}
// 导出优惠券到任务
export const exportCouponForFmsToTask = (data) => {
  return request(
    `${UrlConfig.GoodsFrontendTenantWeb.ExportCouponForFmsToTask}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    return resp
  })
}
// 根据优惠券ID查询优惠券详情
export const findResponseByCouponId = (data) => {
  return request(
    `${UrlConfig.PlusFmsWeb.FindResponseByCouponId}`,
    {
      method: METHODS.POST,
      data,
    }
  ).then((resp: any) => {
    return resp
  })
}

